import type { DefaultError, UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import authenticatedApi from "@/lib/api/client";

export function useChatMentionableUsers(
  requestId: number | undefined,
): UseQueryResult<Array<{ id: string; label: string }>, DefaultError> {
  const { isTemplate } = useIsTemplate();

  return useQuery<
    Array<{ id: string; name: string }>,
    DefaultError,
    Array<{ id: string; label: string }>
  >({
    enabled: !!requestId && !isTemplate,
    initialData: [],
    queryFn: async () => {
      if (!requestId) return [];

      try {
        return await authenticatedApi
          .url(`/requests/${requestId}/mentionable-users`)
          .get()
          .json();
      } catch {
        return [];
      }
    },
    queryKey: ["chatMentionableUsers", requestId],
    select: (data) =>
      data.map((user) => ({
        id: user.id.toString(),
        label: user.name,
      })),
  });
}
